/**
 * Created by tdunham on 7/28/2017.
 */

export class Position {

	public id:                  number;     // The ID of the position in the Angular ReST API.
	public poscode:             string;     // The abbreviation of the position's name ('QB').
	public title:               string;     // The name of the position ('Quarterback').
	public code:                string;     // The sport associated with this position ('NFL').
	public priority:            number;     // Used to sort the names for display.
	public nfl_inactives_list:  number;     // Does this entry show in the NFL inactives list? 0 = False, 1 = True


	constructor( values: Object = {} ) {

		Object.assign( this, values );

	}

}



// WEBPACK FOOTER //
// ./src/app/services/position/position.ts